import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import moment from 'moment'
import { Card, InputAdornment, Popover } from "@mui/material";
import { UtilityService } from "../../../services/UtilityService";
import { ScheduleMessageIcon, UpArrowIcon, DownArrowIcon } from "../../../icon";


interface Props {
    handleChange: (time: number) => void;
    Value: number;
    IsMobileDevice?: boolean;
    TextLabel?: string;
}

const ArrowTimePickerComponent = (props) => {
    let TimeValueLocal = props.Value !== -1 && new Date(props.Value)?.toString() !== "Invalid Date" ? new Date(props.Value) : UtilityService.getPreferredTimeZoneTimeNow();

    const [TimeValue, SetTimeValue] = useState(TimeValueLocal)
    const [anchorEl, setAnchorEl] = useState();
    const [selectedHour, setSelectedHour] = useState(-1);
    const [selectedMinute, setSelectedMinute] = useState(-1);
    const [meridian, setMeridian] = useState("");
    const [minutes, setMinutes] = useState("");
    const [IsAMMeridiem, setIsAMMeridiem] = useState(Math.floor(TimeValue.getHours() / 12) === 0);

    useEffect(() => {
        setSelectedHour(calculateHour(moment(TimeValue).format(`HH:mm`)))
        setSelectedMinute(calculateMinutes(moment(TimeValue).format(`HH:mm`)))
        setMeridian(calculateMeridian(moment(TimeValue).format(`HH:mm`)))
        setMinutes(calculateMinutes(moment(TimeValue).format(`HH:mm`)).toString())
        setIsAMMeridiem(Math.floor(calculateHour(moment(TimeValue).format(`HH:mm`)) / 12) === 0)
    }, [])

    useEffect(() => {
        let time = props.Value !== -1 && new Date(props.Value)?.toString() !== "Invalid Date" ? new Date(props.Value) : UtilityService.getPreferredTimeZoneTimeNow();
        setSelectedHour(calculateHour(moment(time).format(`HH:mm`)))
        setSelectedMinute(calculateMinutes(moment(time).format(`HH:mm`)))
        setMeridian(calculateMeridian(moment(time).format(`HH:mm`)))
        setMinutes(calculateMinutes(moment(time).format(`HH:mm`)).toString())
        setIsAMMeridiem(Math.floor(calculateHour(moment(time).format(`HH:mm`)) / 12) === 0)
    }, [props.Value])

    const handleClick = (event: any) => {
        event.preventDefault();
        setAnchorEl(event.currentTarget)
        onSelectedTimeChange(selectedHour, selectedMinute);
    };

    const handleClose = () => {
        setAnchorEl(null)
    };

    const calculateMinutes = (time: any) => {
        const splittedTime = time && moment(time, "HH:mm").format("HH:mm").split(":");
        return Number(splittedTime[1]?.split(" ")[0] || 0);
    };

    const calculateHour = (time: any) => {
        const splittedTime = time && moment(time, "HH:mm").format("HH:mm").split(":");
        return Number(splittedTime[0]);
    };

    const calculateMeridian = (time: any) => {
        const hour = calculateHour(time);
        const meridian = moment().hour(hour).localeData().meridiem(hour, 0, true);
        return meridian;
    };

    const UpArrowHour = () => {
        let hours = (selectedHour + 1) % 24;
        setSelectedHour(hours)
        onSelectedTimeChange(hours, selectedMinute);
    }

    const DownArrowHour = () => {
        let hours = selectedHour - 1;
        if (hours < 0) {
            hours += 24;
        }
        setSelectedHour(hours)
        onSelectedTimeChange(hours, selectedMinute);
    }

    const onSelectedTimeChange = (selectedHour, selectedMinute) => {
        handleTimeClick(selectedHour, selectedMinute);
    }

    const handleTimeClick = (selectedHour, selectedMinute) => {
        let time = (selectedHour !== -1 && selectedMinute !== -1) ? new Date(new Date(UtilityService.getPreferredTimeZoneTimeNow().setHours(selectedHour)).setMinutes(selectedMinute)) : UtilityService.getPreferredTimeZoneTimeNow();
        time = time.toString() !== "Invalid Date" ? time : TimeValue;
        SetTimeValue(time)
        props.handleChange(time.getTime());
    }

    const getHoursNumber = (hours: number) => (hours === 0 ? ((hours + 11) % 12) + 1 : ((hours - 1) % 12) + 1)

    const UpArrowMinute = () => {
        let mins = (selectedMinute + 1) % 60;
        setSelectedMinute(mins)
        onSelectedTimeChange(selectedHour, mins)
    }

    const DownArrowMinute = () => {
        let mins = (selectedMinute - 1);
        if (mins < 0) {
            mins += 60;
        }
        setSelectedMinute(mins)
        onSelectedTimeChange(selectedHour, mins)
    }

    const handleMeridiem = (flag: boolean) => {
        const newIsAMMeridiem = !IsAMMeridiem;
        setIsAMMeridiem(newIsAMMeridiem);
        let newHour = selectedHour;
        if (newIsAMMeridiem) {
            newHour -= 12;
        } else {
            newHour += 12;
        }
        setSelectedHour(newHour);
        let newTime = new Date(TimeValue);
        newTime.setHours(newHour);
        SetTimeValue(newTime);
        onSelectedTimeChange(newHour, selectedMinute);
    };

    return <div>
        <TextField
            size="small"
            fullWidth
            id="input-with-icon-textfield"
            label={props.TextLabel}
            className="br-1"
            tabIndex={17}
            onClick={handleClick}
            value={props.Value === -1 || new Date(props.Value)?.toString() === "Invalid Date" ? "HH:mm" : `${moment(props.Value).format("hh:mm")} ${IsAMMeridiem ? "AM" : "PM"}`}
            InputProps={{
                classes: { input: 'h6-regular color-text-field-font', notchedOutline: 'br-text-field w-fill' },
                startAdornment: (
                    <InputAdornment  position="start">
                        <button tabIndex={17} data-up-arrow-index={300} onClick={handleClick} className="d-flex align-center">
                            <ScheduleMessageIcon className={`c-pointer`}
                            />
                        </button>
                    </InputAdornment>
                ),
            }}
            variant="outlined"
        />

        <Popover
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
        >
            <Card style={{ display: "flex" }}>
                <div className="d-flex justify-between w-p-100 p-1">
                    <div>
                        <UpArrowIcon className={`px-2 c-pointer`} onClick={UpArrowHour} />
                        <div className={"h4-bold time_header p-1 bg-color-display-time br-2"}>
                            {`${getHoursNumber(selectedHour).toString().length === 1 ? '0' : ''}${getHoursNumber(selectedHour)}`}
                        </div>
                        <DownArrowIcon className={`px-2 c-pointer`} onClick={DownArrowHour} />
                    </div>
                    <div className="my-auto p-1 h2-bold">:</div>
                    <div>
                        <UpArrowIcon className={`px-2 c-pointer`} onClick={UpArrowMinute} />
                        <div className={"h4-bold time_header p-1 bg-color-display-time br-2"}>
                            {`${selectedMinute.toString().length === 1 ? '0' : ''}${selectedMinute}`}

                        </div>
                        <DownArrowIcon className={`px-2 c-pointer`}
                            onClick={DownArrowMinute}
                        />
                    </div>
                    <div>
                        <div className={`h4-bold time_header px-1 ${IsAMMeridiem ? 'bg-color-diaplay-time-hour-period time-meridiem-border' : 'bg-color-disabled-time-hour-period time-disable-meridiem-border '} c-pointer  color-secondary `} onClick={() => handleMeridiem(true)}>
                            AM
                        </div>
                        <div className={`h4-bold time_header px-1 ${!IsAMMeridiem ? 'bg-color-diaplay-time-hour-period time-meridiem-border' : 'bg-color-disabled-time-hour-period time-disable-meridiem-border '} c-pointer color-secondary mt-1`} onClick={() => handleMeridiem(false)}>
                            PM
                        </div>
                    </div>
                </div>
            </Card>
        </Popover>

    </div>;
}

export default ArrowTimePickerComponent;
